<template>
    <van-nav-bar
        :left-text="leftText"
        :right-text="rightText"
        :left-arrow="leftArrow"
        @click-left="onClickLeft"
        @click-right="onClickRight"
    >
    <template #title>
        <div class="title">{{ title }}</div>
    </template>
    </van-nav-bar>
</template>

<script>
export default {
    name:'NavBar',
    props:{
        title:{
            type: String,
            default:''
        },
        leftText:{
            type: String,
            default:''
        },
        rightText:{
            type: String,
            default:''
        },
        leftArrow:{
            type: Boolean,
            default:false
        }
    },
  data() {
    return {
        
    };
  },
  methods:{
    onClickLeft(){
        this.$router.back()
    },
    onClickRight(){
        this.$emit('rightBtn')
    }
  }
};
</script>

<style scoped>
.title{
    color: #222222;
    font-size: 0.346rem;
}

</style>
<style>
.van-nav-bar .van-icon{
    color: #666666;
}
.van-nav-bar__text{
    color: #222222;
}
</style>